import { EditorColoringType } from '@editor/interfaces'
import { RootState } from '@editor/store/app'
import { createSelector } from '@reduxjs/toolkit'
import { merge } from 'lodash'

import { DefaultEditorDisplayConfig } from '../constants'

export const selectDefaultEditorDisplaySettings = createSelector(
  (state: RootState) => state.user.userProfile?.display_config,
  (displayConfig) => merge({}, displayConfig, DefaultEditorDisplayConfig),
)

export const selectUnlabeledColor = createSelector(
  (state: RootState) => state.editorSettings.display.general.unlabeled_color,
  (unlabeledColor) => unlabeledColor,
)

export const selectisGroupColoring = createSelector(
  [
    (state: RootState) => state.editorSettings.display.general.display_type,
    (state: RootState) => state.inspectionGroup.groups,
  ],
  (displayType, inspectionGroups) =>
    displayType === EditorColoringType.Group ||
    (displayType === EditorColoringType.Auto && inspectionGroups.length > 0),
)

export const selectIsAdjustingUnlabeledColors = createSelector(
  [
    (state: RootState) => state.toolUtil.core.currentFillColor,
    (state: RootState) => state.toolUtil.core.currentAdjustingKey,
  ],
  (currentFillColor, currentAdjustingKey) =>
    currentFillColor !== undefined && currentAdjustingKey === 'general.unlabeled_color',
)

export const selectIsAdjustingLabelColors = createSelector(
  [
    (state: RootState) => state.toolUtil.core.currentLabelTextColor,
    (state: RootState) => state.toolUtil.core.currentLabelBackgroundColor,
  ],
  (currentLabelTextColor, currentLabelBackgroundColor) =>
    currentLabelTextColor !== undefined || currentLabelBackgroundColor !== undefined,
)
